import React, { useEffect, useLayoutEffect, useState } from "react";
import { useLazyQuery } from "@apollo/client";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import moment from "moment";

import { clientWellness } from "../../App";
import {
  ButtonCreateEvent,
  ContentCalendarHome,
  ContentDayEvents,
} from "./CalendarHomeContainer.styled";
import {
  ALL_CATEGORIES_CALENDAR,
  EVENT_CALENDAR_FILTERED,
} from "../../GraphQL/Queries";
import { getStateLoginComplete } from "../LayoutHome/stateLogin";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";

const CalendarHomeContainer = ({isAgent}) => {
  const [categories, setCategories] = useState([]);
  const [startSearch] = useState(moment().startOf("year"));
  const [endSearch] = useState(moment().endOf("year"));
  const [eventList, setEventList] = useState([]);
  const [date, setDate] = useState(new Date());
  const [events, setEvents] = useState([]);
  const [filterEvents, setfilterEvents] = useState([]);
  const [user] = useState(getStateLoginComplete());
  const history = useHistory();

  const [runQueryGetCategories] = useLazyQuery(ALL_CATEGORIES_CALENDAR, {
    client: clientWellness,
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      let categories = data?.allCategories.map((category) => {
        return category?.idCategory;
      });
      setCategories(categories);
    },
  });

  const [runQueryGetEventsFiltered] =
    useLazyQuery(EVENT_CALENDAR_FILTERED, {
      client: clientWellness,
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        setEventList(data.myCalendar);
      },
    });

  const handleTileClassName = ({ date }) => {
    const tileDate = new Date(date);
    const isPast = eventList.some((event) => {
      const eventDate = new Date(event.startDate);
      return (
        eventDate.getDate() === tileDate.getDate() &&
        eventDate.getMonth() === tileDate.getMonth() &&
        eventDate.getFullYear() === tileDate.getFullYear() &&
        tileDate < new Date()
      );
    });

    const isFuture = eventList.some((event) => {
      const eventDate = new Date(event.startDate);
      return (
        eventDate.getDate() === tileDate.getDate() &&
        eventDate.getMonth() === tileDate.getMonth() &&
        eventDate.getFullYear() === tileDate.getFullYear() &&
        tileDate >= new Date()
      );
    });

    const isInEventRange = eventList.some((event) => {
      const eventStartDate = new Date(event.startDate);
      const eventFinishDate = new Date(event.finishDate);
      return tileDate >= eventStartDate && tileDate <= eventFinishDate;
    });

    if (isPast) {
      return "event-past";
    }
    if (isFuture) {
      return "event-future";
    }

    if (isInEventRange) {
      return "event-in-range";
    }
  };

  const handleGoToCreateEvent = () => {
    history?.push({
      pathname: `/ManageEvent`,
      state: { path: `/Home` },
    });
  };

  useEffect(() => {
    runQueryGetCategories();
  }, []);

  useEffect(() => {
    runQueryGetEventsFiltered({
      variables: {
        idCategory: categories,
        userId: user.userId,
        startSearch: startSearch.format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"),
        endSearch: endSearch.format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"),
      },
    });
  }, [categories]);

  useEffect(() => {
    const filter = [];
    eventList.forEach((evento) => {
      const eventStartDate = new Date(evento.startDate);
      const eventFinishDate = new Date(evento.finishDate);
      eventStartDate.setHours(0, 0, 0, 0);
      eventFinishDate.setHours(0, 0, 0, 0);

      const dateSelect = new Date(date);
      dateSelect.setHours(0, 0, 0, 0);

      const dateInsideRange =
        dateSelect >= eventStartDate && dateSelect <= eventFinishDate;

      if (dateInsideRange) {
        filter.push(evento);
      }
    });
    setfilterEvents(filter);
  }, [eventList, date]);

  useLayoutEffect(() => {
    const uniqueStartTimes = new Set();
    const filteredEvents = filterEvents.filter((evento) => {
      const startTime = new Date(evento.startDate);
      const startHour = startTime.getUTCHours();
      const startMinute = startTime.getUTCMinutes();
      const timeString = `${startHour}:${startMinute}`;

      if (!uniqueStartTimes.has(timeString)) {
        uniqueStartTimes.add(timeString);
        return true;
      }
      return false;
    });
    const eventosOrdenados = filteredEvents.sort((a, b) => {
      const fechaInicioA = new Date(a.startDate);
      const fechaInicioB = new Date(b.startDate);

      return fechaInicioA - fechaInicioB;
    });
    setEvents(eventosOrdenados);
  }, [filterEvents]);

  return (
    <ContentCalendarHome>
      <Calendar
        value={date}
        onChange={setDate}
        tileClassName={handleTileClassName}
        locale="en"
      />
      <ContentDayEvents>
        <p className="calendar-home_day">
          Day events:
          <span>{moment(date).format("MMMM DD / YYYY")}</span>
        </p>
        <ButtonCreateEvent hidden={isAgent} onClick={() => handleGoToCreateEvent()}>
          +
        </ButtonCreateEvent>
      </ContentDayEvents>

      {events.length > 0 ? (
        <ul className="calendar-home_list">
          {events.map(
            (event, index) =>
              index < 3 && (
                <li key={event.idEvent}>
                  {event.eventName}
                  <span className="calendar-home_hour">
                    {moment(event.startDate).format("hh:mm A")}
                  </span>
                </li>
              )
          )}
        </ul>
      ) : (
        <ul className="calendar-home_list">
          {filterEvents.map(
            (event, index) =>
              index < 3 && (
                <li key={event.idEvent}>
                  {event.eventName}
                  <span className="calendar-home_hour">
                    {moment(event.startDate).format("hh:mm A")}
                  </span>
                </li>
              )
          )}
        </ul>
      )}
    </ContentCalendarHome>
  );
};

export default CalendarHomeContainer;

CalendarHomeContainer.propTypes = {
  isAgent: PropTypes.bool,
};
